import { render } from "./SnacksQueue.vue?vue&type=template&id=529a9830"
import script from "./SnacksQueue.vue?vue&type=script&lang=js"
export * from "./SnacksQueue.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__